// extracted by mini-css-extract-plugin
export default {"notfound":"NotFound_notfound__oDF2U","text":"NotFound_text__OfBlj","notify":"NotFound_notify__qRYCr","h3":"NotFound_h3__hR5wH"};